@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';

:host {
  background-color: var(--white-layout-302-level-1-elevation);
  color: var(--body-text-arrows-400);
  padding-top: calc(var(--spacer) * 1.5);
  padding-bottom: calc(var(--spacer) * 1.5);
}

.wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  &.is-loading {
    .ws-list {
      display: none;
    }
  }
}

.content {
  width: 100%;
  height: 200px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.widget-loading {
  bottom: calc(var(--spacer) * 1.5);
}

.ws-list {
  width: 100%;
}

gz-progress {
  width: 60%;
}

.gz-data-item {
  height: 15px;
  margin-bottom: calc(var(--spacer) * 2);
  align-items: center;

  &--title {
    width: 25%;
    margin-right: calc(var(--spacer) * 2);
  }

  &--value {
    min-width: 30px;
    color: var(--main-titles-inputs-600);
  }

  &--delta {
    font-weight: bold;
    width: 10%;

    &.success {
      color: var(--green-layout-101-primary-green);
    }
  }

  &--value,
  &--delta {
    margin-bottom: 0;
    margin-left: var(--spacer);
  }
}

@media screen and (max-width: 1600px) {
  .is-empty,
  .is-error {
    .gz-data-item {
      &--title {
        margin-right: var(--spacer);
      }

      &--value {
        margin-left: var(--spacer);
      }
    }

    gz-progress {
      width: 55%;
    }
  }
}

:host([data-display-mode='pdf']) {
  gz-progress {
    width: 49%;
  }

  .gz-data-item {
    font-size: calc(var(--body-size) - 3px);
  }

  .gz-data-item--value {
    margin-bottom: auto;
    font-size: var(--body-size);
  }

  .gz-data-item--title {
    width: 36%;
  }

  .gz-data-item--delta {
    align-self: center;
    margin-bottom: auto;
  }
}
